'use client';

import React from 'react';
import Image from 'next/image';
import { useUser } from '../../../context/userContext';
import { UserMenuProps } from '../types';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const UserMenu: React.FC<UserMenuProps> = ({ showBalance = false, className }) => {
  const { user } = useUser();

  if (!user) return null;

  // TEMPORARY: Force gradient to show for testing
  const forceGradient = true; // Set to false to restore normal behavior

  return (
    <div className={cn('flex items-center', className)}>
      <Button variant='ghost' size='icon' className='rounded-full p-0 w-10 h-10'>
        {user?.profileImage && !forceGradient ? (
          <Image
            priority
            width={40}
            height={40}
            className='rounded-full aspect-square object-cover hover:scale-105 transition-transform'
            src={user.profileImage}
            alt='User avatar'
            onError={e => {
              const target = e.target as HTMLImageElement;
              target.src = '/default-avatar.png';
            }}
          />
        ) : (
          <div className='w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 flex items-center justify-center hover:scale-105 transition-transform' />
        )}
      </Button>
    </div>
  );
};
